import {
    buildVDPBaseUrl,
    listingDataPreprocessing,
} from '@/utilities/dispatchUtils';

import {
    expiredListingDuck,
    globalConfigsDuck,
    inventoryDuck,
    ownersDuck,
} from '@/ducks';

import {
    invActiveEmailListingDuck,
    invResultsDuck,
} from '@/ducks/inv';

export default function dispatchInvDetailsPageData() {
    return async (ctx) => {

        const state = ctx.store.getState();
        const isKbb = globalConfigsDuck.selectors.isKbb(state);

        const vdpUrl = await buildVDPBaseUrl(ctx);

        // Create batched action queue
        ctx.batchDispatch.createActions((deferredCtx) => {

            // Feature Flags
            const {
                brand: [, { inventory_image_url: inventoryImageUrl }],
            } = ctx.useFeatures([
                'brand',
            ]);

            const {
                listings = [],
                owners = [],
            } = deferredCtx.data;

            // account for lsc or cs response
            const listing = listings?.[0] || deferredCtx?.data;

            const owner = owners?.[0] || deferredCtx?.data?.owner || {};

            listingDataPreprocessing({
                displayPhoneNumber: true,
                inventoryImageUrl,
                listing,
                owners,
                vdpUrl,
                maxImageCount: 3,
            });

            const listingId = listing?.id || deferredCtx.query.listingId;

            if (deferredCtx.query?.clickType && !listing.clickType) {
                listing.clickType = deferredCtx.query.clickType;
            }

            return [
                // Add owner to listings collection
                ownersDuck.creators.addOwners({ [owner.id]: owner }),

                // Update the inventory collection
                inventoryDuck.creators.addInventory([listing], isKbb),

                // emailOwner
                invActiveEmailListingDuck.creators.setActiveResults([listingId]),

                // Map the order to display results
                invResultsDuck.creators.setActiveResults([listingId]),

                // Update listing fetching status if VDP endpoint fails
                invResultsDuck.creators.setFetchError(!listing.id),

                expiredListingDuck.creators.setKeys(listing?.expiredListing),
            ];
        });
        // dispatch the batched action queue
        await ctx.batchDispatch.dispatchActions(ctx);
    };
}
